import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

const KEY_BYPASS_PROPUESTA = '@as_gastronomico/votar_ubicacion_bypass_propuesta';
const KEY_BYPASS_QR = '@as_gastronomico/votar_ubicacion_bypass_qr';

async function writeBypassKey(key: string, value: string): Promise<void> {
  if (Platform.OS === 'web' && typeof sessionStorage !== 'undefined') {
    try {
      sessionStorage.setItem(key, value);
    } catch {
      /* ignore */
    }
    return;
  }
  try {
    await AsyncStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

async function readAndClearBypassKey(key: string, expected: string): Promise<boolean> {
  const want = String(expected);
  if (Platform.OS === 'web' && typeof sessionStorage !== 'undefined') {
    try {
      const got = sessionStorage.getItem(key);
      if (got === want) {
        sessionStorage.removeItem(key);
        return true;
      }
    } catch {
      /* ignore */
    }
    return false;
  }
  try {
    const got = await AsyncStorage.getItem(key);
    if (got === want) {
      await AsyncStorage.removeItem(key);
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/** Antes de recargar en /votar/:propuestaId (botón inferior «Activa la ubicación»). */
export function marcarUbicacionBypassVotarPropuesta(propuestaId: string): void {
  void writeBypassKey(KEY_BYPASS_PROPUESTA, String(propuestaId));
}

export async function consumirUbicacionBypassVotarPropuesta(
  propuestaId: string
): Promise<boolean> {
  return readAndClearBypassKey(KEY_BYPASS_PROPUESTA, String(propuestaId));
}

/** Antes de recargar en ficha QR pública. */
export function marcarUbicacionBypassVotarQr(codigoQr: string): void {
  void writeBypassKey(KEY_BYPASS_QR, String(codigoQr));
}

export async function consumirUbicacionBypassVotarQr(codigoQr: string): Promise<boolean> {
  return readAndClearBypassKey(KEY_BYPASS_QR, String(codigoQr));
}
